export default __webpack_public_path__ + "static/media/bmsTestJigLogo.9ec7424a.png";